import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { caseStudies } from "../data";
import { Reveal } from "./Primitives";

export const CaseStudies = () => {
  return (
    <section id="work" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-16">
            <div>
              <span className="text-sm font-medium text-[#A1A1AA] tracking-wide">Selected Work</span>
              <h2 className="mt-3 font-display text-4xl sm:text-5xl font-light tracking-tight max-w-2xl leading-tight">
                Real sites, built for real businesses.
              </h2>
            </div>
            <p className="max-w-sm text-[#52525B] leading-relaxed">
              A few of the brands we've helped launch — across travel, events, trades and media.
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-x-8 gap-y-16">
          {caseStudies.map((cs, i) => (
            <Reveal key={cs.client} delay={(i % 2) * 0.1}>
              <a
                href={cs.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`case-study-${i}`}
                className="group block"
              >
                <div className="relative overflow-hidden rounded-2xl border border-black/5 bg-[#F4F4F5] aspect-[4/3]">
                  <motion.img
                    src={cs.image}
                    alt={cs.client}
                    className="absolute inset-0 h-full w-full object-cover object-top"
                    initial={{ scale: 1.02 }}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  <div className="absolute bottom-5 right-5 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                    <span className="inline-flex items-center gap-1.5 bg-white text-[#0A0A0A] text-sm font-medium px-4 py-2 rounded-full">
                      View live site <ArrowUpRight className="h-4 w-4" />
                    </span>
                  </div>
                </div>

                <div className="mt-5 flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-display text-xl font-medium tracking-tight">{cs.client}</h3>
                    <p className="mt-1 text-sm text-[#52525B] leading-relaxed max-w-md">{cs.blurb}</p>
                  </div>
                  <span className="shrink-0 mt-1 text-xs font-medium text-[#52525B] border border-black/10 rounded-full px-3 py-1">
                    {cs.industry}
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
